import { Module } from '@nestjs/common';
import {appSettings} from '../../../config';
import { AppController } from './app.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppService } from './app.service';
import { ContainerModule } from './container/container.module';
import { InvoiceModule } from './invoice/invoice.module';
import { Invoice } from './invoice/invoice.entity';
import { InvoiceItems } from './invoice/invoice-items.entity';
import { Container } from './container/container.entity';
import { ContainerLog } from './container/container-log.entity';
import { DocumentsModule } from './documents/documents.module';
import { DocumentsListModule } from './documents-list/documents-list.module';
import { DocumentsList } from './documents-list/documents-list.entity';
import { LogBookItems } from './log-book-items/log-book-items.entity';
import { ContainerLogBook } from './container-log-book/container-log-book.entity';
import { ContainerLogBookModule } from './container-log-book/container-log-book.module';
import { LogBookItemsModule } from './log-book-items/log-book-items.module';
import { LoadingSheetEntity } from './container/dto/loading-sheet-entity';
import { PostShipmentDetailsEntity } from './container/dto/post-shipment-details-entity';
import { ExpensesLogisticsEntity } from './container/dto/expenses-logistics-entity';
import { ExpensesLogisticsUpdateEntity } from './container/dto/expenses-logstics-update-entity';
import { ScheduleModule } from '@nestjs/schedule';
@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: 'mysql',
    // host: '142.93.219.119',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.logistics_db,
      entities: [Invoice,InvoiceItems, Container, ContainerLog,DocumentsList,ContainerLogBook,LogBookItems,LoadingSheetEntity,PostShipmentDetailsEntity,PostShipmentDetailsEntity,ExpensesLogisticsEntity,ExpensesLogisticsUpdateEntity],
      synchronize: false,
      logging: true
  }),
    ContainerModule, InvoiceModule, DocumentsListModule,ContainerLogBookModule,LogBookItemsModule],
})
export class AppModule {}
